<template>
    <header class="navbar">
        <div class="container navbar-content">
            <!-- Logo always links to the dashboard for the stylist -->
            <router-link to="/stylist/dashboard" class="logo">KC-Afrobraids</router-link>

            <div class="nav-right">
                <!-- Desktop Navigation Links -->
                <nav class="nav-links">
                    <router-link :to="{name: 'StylistProfile'}">PROFILE</router-link>
                    <a href="#" @click.prevent="handleLogout" class="logout-link">LOGOUT</a>
                </nav>
                
                <!-- Mobile Menu Toggle Button -->
                <button class="menu-toggle" @click="toggleMenu" aria-label="Toggle Menu">
                    {{ isMobileMenuOpen ? '✕' : '☰'}}
                </button>
            </div>
        </div>
        
        <!-- Mobile Menu: v-show handles visibility, fixed display flex -->
        <nav class="mobile-menu" v-show="isMobileMenuOpen">
            <router-link :to="{name: 'testimonial'}" @click="closeMenu">PROFILE</router-link>
            <a href="#" @click.prevent="handleLogout" class="logout-link">LOGOUT</a>
        </nav>
        
    </header>
</template>

<script>
//import  { apiClient } from '@/services/ApiClient'
import { useAuthStore } from '@/stores/authStore'
import { logoutUser } from '@/services/AxiosClient';

export default {
    name: 'StyleNav',
    data(){ return{
        isMobileMenuOpen: false
    }
    },
    methods: {
        async handleLogout() {
            const authStore = useAuthStore();
            
            // 1. Clear Pinia State
            authStore.clearStylistSession(); 
            
            // 2. Clear LocalStorage and Redirect
            logoutUser(); 
            
            //this.closeMenu();
        },
        toggleMenu() {
            this.isMobileMenuOpen = !this.isMobileMenuOpen;
        }
    }
}
</script>

<style scoped>

    a {
        text-decoration: none;
        color: inherit;
    }

    .container {
        max-width: 1200px;
        margin: 0 auto;
        padding: 0 1rem;
    }

    /* 1. Navbar Styling */
    .navbar {
        background-color: var(--color-dark);
        box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
        position: sticky;
        top: 0;
        z-index: 1000;
    }

    .navbar-content {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 1rem 0;
    }
    
    .nav-right {
        display: flex;
        align-items: center;
    }

    /*Logo */
    .logo {
        font-size: 1.875rem; 
        font-family: var(--font-serif);
        font-weight: 800;
        color: var(--color-gold); 
        letter-spacing: 0.05em;
    }

    /* 3. Desktop Nav Links (Hidden by default for mobile) */
    .nav-links {
        display: none; 
        align-items: center;
        gap: 1.5rem;
    }
    
    .nav-links a {
        padding: 0.5rem 1rem;
        color: var(--color-light); 
        transition: color 0.3s;
    }

    .nav-links a:hover,
    .nav-links a.router-link-exact-active {
        color: var(--color-gold); 
    }

    /* 3a. Desktop Logout Link Styles (From your request) */
    .nav-links .logout-link {
        padding: 0.5rem 1rem;
        color: var(--color-light); 
        transition: color 0.3s;
    }
    .nav-links .logout-link:hover {
        color: var(--color-gold); 
    }

    /* 4. Menu Toggle */
    .menu-toggle {
        display: block; /* Visible on mobile */
        font-size: 1.5rem;
        cursor: pointer;
        border: none;
        background: none;
        color: var(--color-gold); 
    }

    /* 5. Mobile Menu */
    .mobile-menu {
        display: flex; 
        flex-direction: column;
        
        background-color: var(--color-dark);
        position: absolute; 
        width: 100%;
        left: 0;
        border-top: 1px solid #4b5563; 
        text-align: center;
        box-shadow: 0 8px 10px rgba(0, 0, 0, 0.4);
    }
    
    .mobile-menu a {
        display: block;
        padding: 0.75rem 1rem;
        color: var(--color-light);
        border-bottom: 1px solid rgba(255, 255, 255, 0.05);
    }
    
    /* 5a. Mobile Logout Link Styles (From your request) */
    .mobile-menu .logout-link {
        display: block;
        padding: 0.75rem 1rem;
        color: var(--color-light);
    }
    .mobile-menu .logout-link:hover {
        background-color: #3f3e3e; /* Specific dark gray hover */
        color: var(--color-gold);
    }
    
    /* 6. Desktop View (>= 768px) */
    @media (min-width: 768px) {
        .nav-links {
            display: flex; /* Show desktop links */
            align-items: center;
            gap: 1.5rem;
        }
        
        .menu-toggle {
            display: none; /* Hide toggle button */
        }

        .mobile-menu {
            display: none !important; /* Forces mobile menu hidden on desktop */
        }
        
        .nav-right {
            /* Ensures items are aligned on desktop */
            gap: 1.5rem; 
        }
    }
</style>